import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Application } from '@shared/models/data-model';
import { RegistrationService } from '@shared/services/registration.service';

export const applicationResolver: ResolveFn<Application> = (route, state) => {
    return inject(RegistrationService).getApplication();
};
